var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurposePrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.48212C9.743 2.48212 7.5 4.72512 7.5 7.48212V10.4821H6.5C5.96957 10.4821 5.46086 10.6928 5.08579 11.0679C4.71071 11.443 4.5 11.9517 4.5 12.4821V20.4821C4.5 21.0126 4.71071 21.5213 5.08579 21.8963C5.46086 22.2714 5.96957 22.4821 6.5 22.4821H18.5C19.0304 22.4821 19.5391 22.2714 19.9142 21.8963C20.2893 21.5213 20.5 21.0126 20.5 20.4821V12.4821C20.5 11.9517 20.2893 11.443 19.9142 11.0679C19.5391 10.6928 19.0304 10.4821 18.5 10.4821H17.5V7.48212C17.5 4.72512 15.257 2.48212 12.5 2.48212ZM9.5 7.48212C9.5 5.82812 10.846 4.48212 12.5 4.48212C14.154 4.48212 15.5 5.82812 15.5 7.48212V10.4821H9.5V7.48212ZM13.5 18.2051V20.4821H11.5V18.2051C11.1504 18.0049 10.8697 17.7034 10.6948 17.3405C10.52 16.9775 10.4593 16.5701 10.5207 16.1719C10.5821 15.7737 10.7627 15.4035 11.0388 15.11C11.3148 14.8166 11.6733 14.6137 12.067 14.5281C12.3594 14.4635 12.6626 14.4653 12.9542 14.5334C13.2459 14.6015 13.5185 14.7343 13.752 14.9218C13.9855 15.1093 14.1739 15.3469 14.3034 15.6169C14.4328 15.887 14.5 16.1826 14.5 16.4821C14.4994 16.8319 14.4067 17.1753 14.2311 17.4778C14.0556 17.7802 13.8034 18.0311 13.5 18.2051Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurposePrivate);
export default __webpack_public_path__ + "static/media/purpose_private.2be85587691b242bcef02654445d14f7.svg";
export { ForwardRef as ReactComponent };